import { VFC } from 'react';
import { useSessionStore } from 'store/session';
import { MenuButton } from '../button/Menu';
import { StyledEmailDiv } from './styled/EmailWrapper';
import { StyledHeaderRightWrapper } from './styled/RightWrapper';

export const HeaderRightSide: VFC = () => {
  const { email } = useSessionStore();
  return (
    <StyledHeaderRightWrapper>
      {email && <StyledEmailDiv>{email}</StyledEmailDiv>}
      <MenuButton />
    </StyledHeaderRightWrapper>
  );
};
